/* JX Buy box: the "picker" and "bundle" (alpha) purchase layouts of sections/jx-buy-box.liquid: selection, pricing,
   gifts, gallery swap, sticky bar and /cart/add.js. Moved out of the section so it loads deferred and caches. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function scrollToBuyBox(root) {
    if (!root) return;
    var target = root.querySelector('[data-jxa-box]') || root.querySelector('.jx-pdp__buy') || root;
    var header = document.querySelector('[data-jh-sticky]');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: top, behavior: behavior });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  var DEFAULT_FMT = '$' + '{' + '{amount}' + '}';

  /* Money formatting learned from a sample Shopify rendered in the visitor's currency (symbol, separators, decimals) */
  function parseMoney(sample, legacyFmt) {
    var legacy = (legacyFmt || DEFAULT_FMT).replace(/<[^>]*>/g, '');
    var m = sample ? /(\d[\d.,'\s\u00a0]*\d|\d)/.exec(sample) : null;
    if (!m) return { legacy: legacy };
    var num = m[1], prefix = sample.slice(0, m.index), suffix = sample.slice(m.index + num.length);
    var seps = num.replace(/\d/g, ''), lastSep = seps.slice(-1), decSep = '', thouSep = '', decimals = 0;
    if (lastSep) {
      var after = num.slice(num.lastIndexOf(lastSep) + 1);
      if (after.length <= 2) { decSep = lastSep; decimals = after.length; thouSep = seps.replace(new RegExp('\\' + lastSep, 'g'), '').charAt(0) || ''; }
      else thouSep = lastSep;
    }
    return { prefix: prefix, suffix: suffix, decSep: decSep, thouSep: thouSep, decimals: decimals };
  }
  /* Currency converter app (Bucks): prices written here are in the store currency, so ask it to convert them again,
     or a converted page shows two currencies after a tier click. Batched to one call per frame. */
  var reconvertQueued = false, reconvertTries = 0;
  function reconvertCurrency() {
    if (reconvertQueued) return;
    var ready = window.bucksCC && typeof window.bucksCC.reConvert === 'function';
    if (!ready) { /* first paint can beat the app's script: try again for a few seconds */
      if (reconvertTries++ < 20) { reconvertQueued = true; setTimeout(function () { reconvertQueued = false; reconvertCurrency(); }, 500); }
      return;
    }
    reconvertQueued = true;
    requestAnimationFrame(function () {
      reconvertQueued = false;
      document.querySelectorAll('[data-jxa], [data-jxp]').forEach(wrapMoney);
      try { window.bucksCC.reConvert(); } catch (e) {}
    });
  }
  /* The app only converts amounts inside <span class="money"> (as Shopify's money format prints them); the prices
     written here are plain text, so wrap each amount in one first */
  function wrapMoney(root) {
    var f = (root.getAttribute('data-money-format') || '').replace(/<[^>]*>/g, '');
    var parts = f.split(/\{\{[^}]*\}\}/);
    if (parts.length < 2 || !(parts[0].trim() || parts[1].trim())) return;
    var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var re = new RegExp(esc(parts[0]) + '\\d(?:[\\d.,\']*\\d)?' + esc(parts[1]), 'g');
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p || p.closest('.money, script, style, template, select, option')) return NodeFilter.FILTER_REJECT;
        re.lastIndex = 0;
        return re.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      re.lastIndex = 0;
      while ((m = re.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var span = document.createElement('span');
        span.className = 'money';
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }
  function fmtMoney(cents, fmt, freeLabel) {
    if (cents === 0 && freeLabel) return freeLabel;
    if (fmt && typeof fmt === 'object' && !fmt.legacy) {
      var val = Math.abs(cents) / 100, whole, frac = '';
      if (fmt.decimals > 0) { var parts = val.toFixed(fmt.decimals).split('.'); whole = parts[0]; frac = parts[1]; }
      else whole = String(Math.round(val));
      if (fmt.thouSep) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thouSep);
      var body = whole + (fmt.decimals > 0 ? fmt.decSep + frac : '');
      return (cents < 0 ? '-' : '') + fmt.prefix + body + fmt.suffix;
    }
    if (fmt && typeof fmt === 'object') fmt = fmt.legacy;
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var key = m ? m[1] : 'amount';
    var n = Math.abs(cents) / 100;
    function group(str, sep) { return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function dec(sepThou, sepDec) { var p = n.toFixed(2).split('.'); return group(p[0], sepThou) + sepDec + p[1]; }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = group(Math.round(n).toString(), ','); break;
      case 'amount_with_comma_separator': out = dec('.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(Math.round(n).toString(), '.'); break;
      case 'amount_with_apostrophe_separator': out = dec("'", '.'); break;
      case 'amount_with_space_separator': out = dec(' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = group(Math.round(n).toString(), ' '); break;
      default: out = dec(',', '.');
    }
    if (cents < 0) out = '-' + out;
    return m ? fmt.replace(m[0], out) : out;
  }
  function moneyShort(cents, fmt) { /* whole amounts without trailing zeros, as money_without_trailing_zeros */
    var s = fmtMoney(cents, fmt, '');
    if (cents % 100 !== 0) return s;
    if (fmt && typeof fmt === 'object' && !fmt.legacy) { return fmt.decimals > 0 ? s.replace(fmt.decSep + new Array(fmt.decimals + 1).join('0'), '') : s; }
    return s.replace(/([.,])00(?!\d)/, '');
  }

  /* Free gifts in the same request as the bottles (one round trip instead of the add, then jx-gifts.js adding the gifts
     and redrawing the drawer). Same rules as assets/jx-gifts.js, which still checks the cart afterwards. */
  /* The cart, read once after load and again after every cart change */
  var cartCache = null;
  function refreshCart() {
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCache = c; return c; })
      .catch(function () { return null; });
  }
  /* A real monthly-tagged eligible subscription line owns the monthly gift set. Cart attributes can
     survive emptying the cart, so an attribute alone must never turn a later control order into treatment. */
  function hasMonthlyGiftLine(cart) {
    var cfg = null;
    try { cfg = JSON.parse(document.getElementById('jx-gifts-config').textContent); } catch (error) {}
    var eligible = cfg && cfg.eligible;
    return (cart.items || []).some(function (line) {
      return line.quantity > 0 && line.selling_plan_allocation &&
        !(line.properties && line.properties._jx_gift) &&
        line.properties && line.properties._jx_gift_track === 'monthly' &&
        (!eligible || eligible.indexOf(line.product_id) !== -1);
    });
  }

  function alignGiftTrack(cart, requestedMonthly, rootPath) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Could not confirm gift selection. Please try again.');
    var monthlyTrack = !!requestedMonthly || hasMonthlyGiftLine(cart);
    var track = monthlyTrack ? 'monthly' : '';
    var current = cart.attributes && cart.attributes._jx_gift_track || '';
    if (current === track) return Promise.resolve({ cart: cart, monthly: monthlyTrack });
    return fetch(rootPath + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _jx_gift_track: track } })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update gift selection');
      return response.json();
    }).then(function (fresh) {
      return { cart: fresh && Array.isArray(fresh.items) ? fresh : cart,
        monthly: !!requestedMonthly || hasMonthlyGiftLine(fresh && Array.isArray(fresh.items) ? fresh : cart) };
    });
  }

  function giftItems(cart, added, sub, once, monthly) {
    var cfg;
    try { cfg = JSON.parse(document.getElementById('jx-gifts-config').textContent); } catch (e) { return []; }
    monthly = !!monthly || hasMonthlyGiftLine(cart);
    var eligible = {};
    (cfg.eligible || []).forEach(function (id) { eligible[id] = true; });
    var isGift = function (l) { return !!(l.properties && l.properties._jx_gift); };
    var subQty = 0, onceQty = 0, have = {};
    (cart.items || []).forEach(function (l) {
      if (isGift(l)) { have[l.variant_id] = true; return; }
      if (!eligible[l.product_id]) return;
      if (l.selling_plan_allocation) subQty += l.quantity;
      else if (l.properties && l.properties._jx_once) onceQty += l.quantity;
    });
    if (sub) subQty += added; else if (once) onceQty += added;
    var out = [], want = {};
    ((monthly ? cfg.giftsMonthly : cfg.gifts) || []).forEach(function (g) { if (g.available && subQty >= g.min) want[g.variant] = g; });
    if (cfg.once && cfg.once.available && !want[cfg.once.variant] && onceQty >= cfg.once.min) want[cfg.once.variant] = cfg.once;
    var anySub = sub || (cart.items || []).some(function (l) { return !isGift(l) && eligible[l.product_id] && l.selling_plan_allocation; });
    Object.keys(want).forEach(function (v) {
      if (have[v]) return;
      var g = want[v], it = { id: g.variant, quantity: 1, properties: { _jx_gift: '1' } };
      if (g.plan && anySub) it.selling_plan = g.plan;
      out.push(it);
    });
    return out;
  }

  function initPicker(root) {
    if (root.jxaBound) return;
    root.jxaBound = true;
    var pdp = root.closest('[data-jx-pdp]') || document;
    var data = { variants: [] };
    try { data = JSON.parse(pdp.querySelector('[data-jx-pdp-data]').textContent); } catch (e) {}
    var cfg = { tiers: [], gifts: [] };
    try { cfg = JSON.parse(root.querySelector('[data-jxa-data]').textContent); } catch (e) {}
    var byId = {};
    (data.variants || []).forEach(function (v) { byId[v.id] = v; });
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
    var giftsCfg = (cfg.gifts || []).slice().sort(function (a, b) { return a.min - b.min; });
    var fmt = parseMoney(root.getAttribute('data-money-sample') || '', root.getAttribute('data-money-format'));
    var freeLabel = root.getAttribute('data-free-label') || '';
    var planId = root.getAttribute('data-plan') || '';
    var useSub = root.getAttribute('data-sub') === 'true' && !!planId;
    var baseId = parseInt(root.getAttribute('data-base'), 10);
    var max = parseInt(root.getAttribute('data-max'), 10) || 12;
    var weeksPer = parseInt(root.getAttribute('data-weeks'), 10) || 4;
    var giftMax = parseInt(root.getAttribute('data-gift-max'), 10) || 1;
    var showPct = root.getAttribute('data-show-pct') === 'true';
    var showValuePct = root.getAttribute('data-show-value-pct') === 'true';
    var showSupply = root.getAttribute('data-show-supply') === 'true';
    var baseOption = root.getAttribute('data-base-option') || '';
    var extras = {};
    (cfg.extras || []).forEach(function (v) { extras[v.option] = v; });
    var vol = {
      on: root.getAttribute('data-vol-on') === 'true',
      threshold: parseInt(root.getAttribute('data-vol-threshold'), 10) || 3,
      mode: root.getAttribute('data-vol-mode') || 'extra',
      type: root.getAttribute('data-vol-type') || 'percent',
      pct: parseFloat(root.getAttribute('data-vol-percent')) || 0,
      unit: parseInt(root.getAttribute('data-vol-unit'), 10) || 0
    };
    function extraFor(name) { /* the extra-bottle product's variant for a flavor, when that mode is on */
      if (vol.mode !== 'product') return null;
      return extras[name] || (flavors.length === 1 ? (cfg.extras || [])[0] : null) || null;
    }
    function volUnit(v, name) { /* the discounted price of one bottle of variant v (name: its flavor) */
      if (vol.mode === 'product') { var ev = extraFor(name === undefined ? baseOption : name); return ev ? unit(ev) : unit(v); }
      if (vol.type === 'price') return vol.unit;
      return Math.round(unit(v) * (100 - vol.pct) / 100);
    }
    function attr(name, fallback) { var v = root.getAttribute(name); return v === null ? fallback : v; }
    var T = {
      add: attr('data-add-label', 'Add to cart'),
      adding: attr('data-adding-label', 'Adding'),
      choose: attr('data-choose-label', 'Choose {n} more'),
      sold: attr('data-soldout-label', 'Sold out'),
      pickPill: attr('data-pick-pill', 'Select a flavor'),
      pickLine: attr('data-pick-line', ''),
      pickBtn: attr('data-pick-button', 'Select a flavor'),
      save: attr('data-save-text', 'Save {save}'),
      one: attr('data-bottles-one', '1 bottle'),
      many: attr('data-bottles-many', '{n} bottles'),
      supply: attr('data-supply-text', '{w}-week supply'),
      perBottle: attr('data-per-bottle', '{price} per bottle'),
      pct: attr('data-pct-text', '{pct}% off'),
      saveGifts: attr('data-save-gifts-text', ''),
      volTeaser: attr('data-vol-teaser', ''),
      volNudge: attr('data-vol-nudge', ''),
      volNudgeAll: attr('data-vol-nudge-all', ''),
      volExtraOne: attr('data-vol-extra-one', ''),
      volExtraMany: attr('data-vol-extra-many', ''),
      volAll: attr('data-vol-all', ''),
      giftsAllVol: attr('data-gifts-all-vol', ''),
      freeBottle: attr('data-free-bottle-text', ''),
      giftsFirst: attr('data-gifts-first', ''),
      giftsNextOne: attr('data-gifts-next-one', ''),
      giftsNextMany: attr('data-gifts-next-many', ''),
      giftsAll: attr('data-gifts-all', ''),
      giftsProgress: attr('data-gifts-progress', '{n} of {max} bottles'),
      giftFree: attr('data-gift-free', 'FREE {value}'),
      giftLocked: attr('data-gift-locked', '{n}+ bottles')
    };
    function money(c) { return fmtMoney(c, fmt, freeLabel); }

    var flavors = Array.prototype.slice.call(root.querySelectorAll('[data-jxa-flavor]')).map(function (el) {
      var v = byId[parseInt(el.getAttribute('data-variant'), 10)];
      return v ? { el: el, name: el.getAttribute('data-value') || '', variant: v, available: !!v.available, count: 0, countEl: el.querySelector('[data-jxa-count]'), stepper: el.querySelector('[data-jxa-stepper]'), plus: el.querySelector('[data-jxa-plus]'), minus: el.querySelector('[data-jxa-minus]') } : null;
    }).filter(Boolean);

    var el = {
      box: root.querySelector('[data-jxa-box]'),
      pill: root.querySelector('[data-jxa-pill]'),
      pillCount: root.querySelector('[data-jxa-pill-count]'),
      pillSep: root.querySelector('[data-jxa-pill-sep]'),
      pillTag: root.querySelector('[data-jxa-pill-tag]'),
      supply: root.querySelector('[data-jxa-sum-supply]'),
      unit: root.querySelector('[data-jxa-sum-unit]'),
      unitCompare: root.querySelector('[data-jxa-sum-unit-compare]'),
      unitPct: root.querySelector('[data-jxa-sum-unit-pct]'),
      total: root.querySelector('[data-jxa-sum-total]'),
      totalPct: root.querySelector('[data-jxa-sum-total-pct]'),
      vol: root.querySelector('[data-jxa-sum-vol]'),
      volText: root.querySelector('[data-jxa-sum-vol-text]'),
      save: root.querySelector('[data-jxa-sum-save]'),
      compare: root.querySelector('[data-jxa-sum-compare]'),
      price: root.querySelector('[data-jxa-sum-price]'),
      free: root.querySelector('[data-jxa-sum-free]'),
      track: root.querySelector('[data-jxa-track]'),
      progress: root.querySelector('[data-jxa-progress]'),
      nudge: root.querySelector('[data-jxa-nudge]'),
      nudgeText: root.querySelector('[data-jxa-nudge-text]'),
      submit: root.querySelector('[data-jxa-submit]'),
      submitLabel: root.querySelector('[data-jxa-submit-label]'),
      error: root.querySelector('[data-jxa-error]'),
      sticky: root.querySelector('[data-jxa-sticky]')
    };
    el.stickyPrice = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-price]') : null;
    el.stickyBtn = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-btn]') : null;
    el.stickyLabel = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-label]') : null;
    var segments = el.track ? Array.prototype.slice.call(el.track.children) : [];
    var giftEls = Array.prototype.slice.call(root.querySelectorAll('[data-jxa-gift]'));
    var track = pdp.querySelector('[data-jx-gal-track]');
    var lastTouched = null;
    var busy = false;

    function unit(v) { return (useSub && v.plans && v.plans[planId] != null) ? v.plans[planId] : v.price; }
    function compare(v) { return v.compare > 0 ? v.compare : v.price; }
    function base() { return byId[baseId] || (flavors[0] && flavors[0].variant) || data.variants[0]; }
    function total() { return flavors.reduce(function (s, f) { return s + f.count; }, 0); }
    function chosen() { return flavors.filter(function (f) { return f.count > 0; }); }
    function tierFor(n) { /* exact tier for n bottles, else the largest tier at or below n */
      var exact = null, below = null;
      tiers.forEach(function (t) { if (t.qty === n) exact = t; else if (t.qty < n && (!below || t.qty > below.qty)) below = t; });
      return { tier: exact || below, exact: !!exact };
    }
    function freeFlavor() { /* the free bottle goes to the flavor with the most bottles, last touched on a tie */
      var best = null;
      chosen().forEach(function (f) { if (!best || f.count > best.count || (f.count === best.count && f === lastTouched)) best = f; });
      return best;
    }
    function compute() {
      var n = total(), r = tierFor(n), free = r.tier ? (r.tier.free || 0) : 0;
      var price = 0, extra = vol.on ? Math.max(0, n - vol.threshold) : 0, volAll = vol.on && vol.mode === 'all' && n > vol.threshold;
      if (volAll) {
        chosen().forEach(function (f) { price += volUnit(f.variant) * f.count; });
      } else if (vol.on && (vol.mode === 'extra' || vol.mode === 'product') && extra > 0) {
        var bottles = [];
        chosen().forEach(function (f) { for (var i = 0; i < f.count; i++) bottles.push(f); });
        bottles.forEach(function (f, i) { price += i < vol.threshold ? unit(f.variant) : volUnit(f.variant, f.name); });
      } else {
        chosen().forEach(function (f) { price += unit(f.variant) * f.count; });
      }
      var cmp = chosen().reduce(function (sum, f) { return sum + compare(f.variant) * f.count; }, 0) + compare(base()) * free;
      var giftValue = 0;
      giftsCfg.forEach(function (g) { if (g.min <= n) giftValue += g.value || 0; });
      return { n: n, tier: r.tier, exact: r.exact, free: free, price: price, cmp: cmp, save: cmp - price, giftValue: giftValue, weeks: (n + free) * weeksPer, extra: extra, volAll: volAll };
    }

    function render() {
      var c = compute(), empty = c.n === 0, b = base();
      if (el.box) el.box.classList.toggle('is-empty', empty);
      if (el.pill) {
        var tag = (c.exact && c.tier && c.tier.tag) ? c.tier.tag : '';
        if (el.pillCount) el.pillCount.textContent = empty ? T.pickPill : (c.n === 1 ? T.one : T.many.replace('{n}', c.n));
        if (el.pillTag) { el.pillTag.textContent = tag; el.pillTag.hidden = empty || !tag; }
        if (el.pillSep) el.pillSep.hidden = empty || !tag;
        el.pill.classList.toggle('is-empty', empty);
        el.pill.classList.toggle('is-tagged', !empty && !!tag);
      }
      if (el.supply) el.supply.textContent = empty ? T.pickLine : (showSupply ? T.supply.replace('{w}', c.weeks) : '');
      var ub = c.volAll ? volUnit(b) : unit(b);
      if (el.unit) el.unit.textContent = T.perBottle.replace('{price}', money(ub));
      if (el.unitCompare) { var uc = compare(b) > ub; el.unitCompare.textContent = uc ? money(compare(b)) : ''; el.unitCompare.hidden = !uc; }
      if (el.unitPct) { var up = compare(b) > ub ? Math.round((compare(b) - ub) / compare(b) * 100) : 0; el.unitPct.textContent = (showPct && up > 0) ? T.pct.replace('{pct}', up) : ''; }
      if (el.vol) {
        var vt = '', teaser = false, vu = volUnit(b, baseOption), vp = money(vu), vd = money(Math.max(0, unit(b) - vu));
        if (vol.on) {
          if (c.n < vol.threshold) { vt = c.n >= vol.threshold - 1 ? T.volTeaser.replace('{n}', vol.threshold + 1) : ''; teaser = true; }
          else if (c.n === vol.threshold) vt = vol.mode === 'all' ? T.volNudgeAll : T.volNudge;
          else if (vol.mode === 'all') vt = T.volAll.replace('{n}', c.n);
          else vt = (c.extra === 1 ? T.volExtraOne : T.volExtraMany).replace('{n}', c.extra);
          vt = vt.replace('{price}', vp).replace('{diff}', vd);
        }
        if (el.volText) el.volText.textContent = vt;
        el.vol.classList.toggle('is-teaser', teaser);
        el.vol.hidden = !vt;
      }
      if (el.save) {
        var tvs = showValuePct ? c.cmp + c.giftValue : c.cmp, saved = tvs - c.price, saveText = '';
        if (!empty && saved > 0) saveText = (showValuePct && c.giftValue > 0 && T.saveGifts) ? T.saveGifts.replace('{save}', money(saved)).replace('{gifts}', moneyShort(c.giftValue, fmt)) : T.save.replace('{save}', money(saved));
        el.save.textContent = saveText;
      }

      var tv = showValuePct ? c.cmp + c.giftValue : c.cmp, tp = tv > 0 ? Math.round((tv - c.price) / tv * 100) : 0;
      if (el.total) el.total.hidden = empty;
      if (el.compare) { var showCmp = !empty && tv > c.price; el.compare.textContent = showCmp ? money(tv) : ''; el.compare.hidden = !showCmp; }
      if (el.price) el.price.textContent = empty ? '' : money(c.price);
      if (el.totalPct) el.totalPct.textContent = (!empty && tp > 0) ? T.pct.replace('{pct}', tp) : '';
      if (el.free) {
        var ff = freeFlavor(), showFree = c.free > 0 && ff && T.freeBottle;
        el.free.textContent = showFree ? T.freeBottle.replace('{n}', c.free).replace('{flavor}', ff.name) : '';
        el.free.hidden = !showFree;
      }
      segments.forEach(function (s, i) { s.classList.toggle('is-on', i < c.n); });
      if (el.progress) el.progress.textContent = T.giftsProgress.replace('{n}', Math.min(c.n, giftMax)).replace('{max}', giftMax);
      if (el.nudge && el.nudgeText) {
        var text = '';
        if (giftsCfg.length) {
          var unlocked = giftsCfg.filter(function (g) { return g.min <= c.n; }).length;
          var next = giftsCfg.filter(function (g) { return g.min > c.n; })[0];
          if (next) {
            var k = next.min - c.n;
            text = (empty && k === 1) ? T.giftsFirst : (k === 1 ? T.giftsNextOne : T.giftsNextMany.replace('{n}', k));
            text = text.replace('{gift}', next.title); text = next.value > 0 ? text.replace('{value}', moneyShort(next.value, fmt)) : text.replace(/\s*\(\{value\}\)|\s*\{value\}/, ''); /* $0 gifts (digital): no price */
          } else text = ((vol.on && T.giftsAllVol) ? T.giftsAllVol.replace('{price}', money(volUnit(b, baseOption))) : T.giftsAll).replace('{n}', unlocked);
        }
        el.nudgeText.textContent = text;
        el.nudge.hidden = !text;
      }
      giftEls.forEach(function (g) {
        var min = parseInt(g.getAttribute('data-unlock'), 10) || 1, on = c.n >= min, val = parseInt(g.getAttribute('data-value'), 10) || 0;
        g.classList.toggle('is-unlocked', on);
        g.classList.toggle('is-locked', !on);
        var pill = g.querySelector('[data-jxa-gift-pill]');
        if (pill) {
          pill.textContent = '';
          if (on) { /* value struck through: FREE $14.95 */
            var parts = (T.giftFree.indexOf('{value}') === -1 ? T.giftFree + ' {value}' : T.giftFree).split('{value}');
            pill.appendChild(document.createTextNode(parts[0] || ''));
            if (parts.length > 1 && val > 0) {
              var struck = document.createElement('s');
              struck.textContent = moneyShort(val, fmt);
              pill.appendChild(struck);
              pill.appendChild(document.createTextNode(parts.slice(1).join('{value}')));
            } else if (parts.length > 1) pill.textContent = (parts[0] + parts.slice(1).join('')).trim(); /* $0 gifts (digital): just "FREE" */
          } else pill.textContent = T.giftLocked.replace('{n}', min);
        }
      });
      flavors.forEach(function (f) {
        if (f.countEl) f.countEl.textContent = f.count;
        if (f.stepper) f.stepper.setAttribute('data-count', f.count);
        f.el.classList.toggle('is-active', f.count > 0);
        if (f.plus) f.plus.disabled = !f.available || c.n >= max;
        if (f.minus) f.minus.disabled = f.count === 0;
      });
      var anySold = chosen().some(function (f) { return !f.available; });
      var allSold = flavors.length > 0 && flavors.every(function (f) { return !f.available; });
      var label, disabled = false;
      if (allSold) { label = T.sold; disabled = true; }
      else if (empty) { label = T.pickBtn; disabled = true; }
      else if (anySold) { label = T.choose.replace('{n}', 1); disabled = true; }
      else label = T.add + ' \u2014 ' + money(c.price);
      if (busy) { label = T.adding; disabled = true; }
      if (el.submitLabel) el.submitLabel.textContent = label;
      if (el.submit) el.submit.disabled = disabled;
      if (el.stickyPrice) el.stickyPrice.textContent = empty ? '' : money(c.price);
      if (el.stickyLabel) el.stickyLabel.textContent = (empty || allSold) ? label : T.add;
      if (el.stickyBtn) el.stickyBtn.disabled = false;
      reconvertCurrency();
      return c;
    }

    /* Gallery: the flavor's image on +, the tier's bundle image when the count matches a tier that has one */
    function scrollTrackTo(slide) {
      if (!track || !slide) return;
      var left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }
    function showMedia(id) {
      if (!id) return;
      var thumb = pdp.querySelector('.jx-gal__thumb[data-media-id="' + id + '"]');
      if (thumb) { thumb.click(); return; }
      scrollTrackTo(pdp.querySelector('.jx-gal__slide[data-media-id="' + id + '"]'));
    }
    function showBundle(c) {
      var target = null, id = (c.exact && c.tier) ? c.tier.id : null;
      pdp.querySelectorAll('.jx-gal__slide--bundle').forEach(function (s) {
        var on = !!(id && s.getAttribute('data-bundle-id') === id);
        s.hidden = !on;
        if (on) target = s;
      });
      if (target) scrollTrackTo(target);
    }

    function bump(f, delta) {
      lastTouched = f;
      if (delta > 0) {
        if (!f.available || total() >= max) return;
        f.count += 1;
        showMedia(f.variant.media);
      } else {
        if (f.count === 0) return;
        f.count -= 1;
      }
      showBundle(render());
    }
    function setTotal(n) { /* editor preview of a tier block: put n bottles on the current flavor */
      var f = (lastTouched && lastTouched.available) ? lastTouched : (chosen()[0] || flavors.filter(function (x) { return x.available; })[0]);
      if (!f) return;
      var others = total() - f.count;
      f.count = Math.max(0, Math.min(max, n) - others);
      showBundle(render());
    }

    function setError(msg) { if (!el.error) return; el.error.textContent = msg || ''; el.error.hidden = !msg; }
    function addToCart() {
      if (busy || !el.submit || el.submit.disabled) return;
      var c = compute(), ff = freeFlavor();
      var items = [], mainLeft = (vol.on && vol.mode === 'product' && c.extra > 0) ? vol.threshold : Infinity;
      chosen().forEach(function (f) {
        var mainQty = Math.min(f.count, mainLeft), extraQty = f.count - mainQty, ev = extraQty > 0 ? extraFor(f.name) : null;
        if (!ev) { mainQty = f.count; extraQty = 0; }
        mainLeft -= mainQty;
        if (mainQty + (f === ff ? c.free : 0) > 0) {
          var it = { id: f.variant.id, quantity: mainQty + (f === ff ? c.free : 0) };
          if (useSub) it.selling_plan = planId;
          items.push(it);
        }
        if (extraQty > 0) {
          var ix = { id: ev.id, quantity: extraQty };
          if (useSub && ev.plans && ev.plans[planId] != null) ix.selling_plan = planId;
          items.push(ix);
        }
      });
      if (!items.length) return;
      busy = true;
      setError('');
      render();
      el.submit.setAttribute('aria-busy', 'true');
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).filter(Boolean).join(','); body.sections_url = window.location.pathname; } catch (e) {}
      }
      var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add to cart');
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res.json }); } catch (e) {}
          document.dispatchEvent(new CustomEvent('jx:cart:added', { detail: res.json }));
          if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res.json);
          else window.location.reload(); /* no drawer on this page: stay here, never send the visitor to /cart */
        })
        .catch(function (err) { setError(err && err.message ? err.message : 'Could not add to cart'); })
        .then(function () { busy = false; el.submit.removeAttribute('aria-busy'); render(); });
    }

    flavors.forEach(function (f) {
      if (f.plus) f.plus.addEventListener('click', function (e) { e.stopPropagation(); bump(f, 1); });
      if (f.minus) f.minus.addEventListener('click', function (e) { e.stopPropagation(); bump(f, -1); });
    });
    if (el.submit) el.submit.addEventListener('click', function (e) { e.stopPropagation(); addToCart(); });
    if (el.stickyBtn) el.stickyBtn.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToBuyBox(root);
    });
    if (el.sticky && el.submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
        el.sticky.classList.toggle('is-on', on);
        el.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (el.stickyBtn) el.stickyBtn.tabIndex = on ? 0 : -1;
      }, { threshold: 0 }).observe(el.submit);
    }
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      tiers.forEach(function (t) { if (t.id === id) setTotal(t.qty); });
    });

    render();
  }

  function initBundle(root) {
    if (root.jxaBound) return;
    root.jxaBound = true;
    var pdp = root.closest('[data-jx-pdp]') || document;
    var data = { variants: [] };
    try { data = JSON.parse(pdp.querySelector('[data-jx-pdp-data]').textContent); } catch (e) {}
    var cfg = { tiers: [], gifts: [], extras: [], flavors: [] };
    try { cfg = JSON.parse(root.querySelector('[data-jxa-data]').textContent); } catch (e) {}
    var byId = {};
    (data.variants || []).forEach(function (v) { byId[v.id] = v; });
    var flavorsCfg = {};
    (cfg.flavors || []).forEach(function (f) { flavorsCfg[f.id] = f; });
    var giftsCfg = (cfg.gifts || []).slice().sort(function (a, b) { return a.min - b.min; });
    var extras = {};
    (cfg.extras || []).forEach(function (v) { extras[v.option] = v; });
    var fmt = parseMoney(root.getAttribute('data-money-sample') || '', root.getAttribute('data-money-format'));
    var freeLabel = root.getAttribute('data-free-label') || '';
    var planId = root.getAttribute('data-plan') || '';
    var useSub = root.getAttribute('data-sub') === 'true' && !!planId;
    var baseId = parseInt(root.getAttribute('data-base'), 10);
    var baseOption = root.getAttribute('data-base-option') || '';
    var hasFlavors = root.getAttribute('data-has-flavors') === 'true';
    /* One-time offer page: one-time bottles tagged _jx_once ('1' first bottle, '2' the discounted added one); its gift
       unlocks on those bottles (theme settings > JCKED free gifts > One-time offer gift) */
    var once = root.getAttribute('data-once') === 'true';
    var addMoreEnabled = root.getAttribute('data-addmore-enabled') === 'true';
    var onceMin = parseInt(root.getAttribute('data-once-min'), 10) || 2;
    /* Split test (Gift set "Monthly gifts"): the cart gets the attribute _jx_gift_track = monthly before the add, so the
       monthly gift set applies (here, assets/jx-gifts.js, the cart drawer), and subscription bottles carry the same
       hidden property so Loop Subscriptions can add the monthly gifts to their first three rebills */
    var monthly = root.getAttribute('data-gift-track') === 'monthly';
    var max = parseInt(root.getAttribute('data-max'), 10) || 6;
    var weeksPer = parseInt(root.getAttribute('data-weeks'), 10) || 4;
    var giftMax = parseInt(root.getAttribute('data-gift-max'), 10) || 1;
    var showValuePct = root.getAttribute('data-show-value-pct') === 'true';
    var vol = {
      on: root.getAttribute('data-vol-on') === 'true',
      threshold: parseInt(root.getAttribute('data-vol-threshold'), 10) || 3,
      mode: root.getAttribute('data-vol-mode') || 'product',
      type: root.getAttribute('data-vol-type') || 'percent',
      pct: parseFloat(root.getAttribute('data-vol-percent')) || 0,
      unit: parseInt(root.getAttribute('data-vol-unit'), 10) || 0
    };
    function attr(name, fallback) { var v = root.getAttribute(name); return v === null ? fallback : v; }
    var T = {
      add: attr('data-add-label', 'Add to cart'),
      adding: attr('data-adding-label', 'Adding'),
      choose: attr('data-choose-label', 'Choose {n} more'),
      sold: attr('data-soldout-label', 'Sold out'),
      bundleBtn: attr('data-bundle-button', 'Choose a bundle'),
      pickBtn: attr('data-pick-button', 'Pick your flavors'),
      slot: attr('data-slot-label', 'Bottle {n}'),
      slotExtra: attr('data-slot-extra-label', 'Extra bottle {n}'),
      pct: attr('data-pct-text', '{pct}% off'),
      save: attr('data-save-text', 'You save {save}'),
      saveGifts: attr('data-save-gifts-text', ''),
      freeBottle: attr('data-free-bottle-text', ''),
      giftsFirst: attr('data-gifts-first', ''),
      giftsNextOne: attr('data-gifts-next-one', ''),
      giftsNextMany: attr('data-gifts-next-many', ''),
      giftsAll: attr('data-gifts-all', ''),
      giftsAllVol: attr('data-gifts-all-vol', ''),
      giftsProgress: attr('data-gifts-progress', '{n} of {max} bottles'),
      giftFree: attr('data-gift-free', 'FREE {value}'),
      giftLocked: attr('data-gift-locked', '{n}+ bottles')
    };
    function money(c) { return fmtMoney(c, fmt, freeLabel); }

    function slotsIn(container) {
      return container ? Array.prototype.slice.call(container.querySelectorAll('[data-jxb-slot]')).filter(function (row) { return row.querySelector('[data-jxb-slot-select]'); }).map(function (row) {
        return { row: row, select: row.querySelector('[data-jxb-slot-select]'), num: row.querySelector('[data-jxb-slot-num]'), img: row.querySelector('[data-jxb-slot-img]'), nameEl: row.querySelector('[data-jxb-slot-name]'), trigger: row.querySelector('[data-jxb-slot-trigger]') };
      }) : [];
    }
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-jxb-tier]')).map(function (el) {
      var paid = parseInt(el.getAttribute('data-qty'), 10) || 1, free = parseInt(el.getAttribute('data-free'), 10) || 0;
      var extraList = el.querySelector('[data-jxb-extra-list]');
      var extras = slotsIn(extraList).map(function (s) { s.price = s.row.querySelector('[data-jxb-slot-price]'); s.remove = s.row.querySelector('[data-jxb-slot-remove]'); return s; });
      var base = slotsIn(el.querySelector('[data-jxb-slots]')).filter(function (s) { return !extraList || !extraList.contains(s.row); });
      return { el: el, paid: paid, free: free, total: paid + free, bump: 0, cmpSet: parseInt(el.getAttribute('data-compare'), 10) || 0, cmpList: (el.getAttribute('data-compare-list') || '').split(',').map(function (n) { return parseInt(n, 10) || 0; }).filter(Boolean), id: el.getAttribute('data-bundle-id'), input: el.querySelector('input[type="radio"]'), priceEl: el.querySelector('[data-jxb-tier-price]'), compareEl: el.querySelector('[data-jxb-tier-compare]'), panel: el.querySelector('[data-jxb-slots]'), slots: base, extras: extras, addMore: el.querySelector('[data-jxb-addmore]'), addRow: el.querySelector('[data-jxb-add-row]'), addBadge: el.querySelector('[data-jxb-add-badge]'), addNum: el.querySelector('[data-jxb-add-num]') };
    });
    var tierIndex = parseInt(root.getAttribute('data-default-tier'), 10);
    if (isNaN(tierIndex) || tierIndex < 0 || tierIndex >= tiers.length) tierIndex = -1;

    var el = {
      box: root.querySelector('[data-jxa-box]'),
      tiersWrap: root.querySelector('[data-jxb-tiers]'),
      total: root.querySelector('[data-jxa-sum-total]'),
      totalPct: root.querySelector('[data-jxa-sum-total-pct]'),
      compare: root.querySelector('[data-jxa-sum-compare]'),
      price: root.querySelector('[data-jxa-sum-price]'),
      save: root.querySelector('[data-jxa-sum-save]'),
      free: root.querySelector('[data-jxa-sum-free]'),
      track: root.querySelector('[data-jxa-track]'),
      progress: root.querySelector('[data-jxa-progress]'),
      nudge: root.querySelector('[data-jxa-nudge]'),
      nudgeText: root.querySelector('[data-jxa-nudge-text]'),
      submit: root.querySelector('[data-jxa-submit]'),
      submitLabel: root.querySelector('[data-jxa-submit-label]'),
      ctaPrice: root.querySelector('[data-jxb-cta-price]'),
      ctaCompare: root.querySelector('[data-jxb-cta-compare]'),
      ctaTotal: root.querySelector('[data-jxb-cta-total]'),
      error: root.querySelector('[data-jxa-error]'),
      saving: root.querySelector('[data-jxb-saving]'),
      savingText: root.querySelector('[data-jxb-saving-text]'),
      sticky: root.querySelector('[data-jxa-sticky]')
    };
    el.stickyPrice = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-price]') : null;
    el.stickyBtn = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-btn]') : null;
    el.stickyLabel = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-label]') : null;
    el.stickyTitle = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-title]') : null;
    el.stickyCompare = el.sticky ? el.sticky.querySelector('[data-jxa-sticky-compare]') : null;
    if (el.sticky) document.documentElement.classList.add('jx-sticky-atc'); /* page bottom padding (sections/jx-buy-box.liquid) */
    var segments = el.track ? Array.prototype.slice.call(el.track.children) : [];
    var giftEls = Array.prototype.slice.call(root.querySelectorAll('[data-jxa-gift]'));
    var track = pdp.querySelector('[data-jx-gal-track]');
    var busy = false;
    el.onceLink = root.querySelector('[data-jxb-once-link]') || pdp.querySelector('[data-jxb-once-link]');
    T.saving = attr('data-saving-text', "You're saving {save} on this order");

    function unit(v) { return (useSub && v.plans && v.plans[planId] != null) ? v.plans[planId] : v.price; }
    function compare(v) { return v.compare > 0 ? v.compare : v.price; }
    function base() { return byId[baseId] || data.variants[0]; }
    function setCompare(x, v) {
      if (!x) return 0;
      var slots = x.slots.concat(x.extras.slice(0, x.bump));
      var count = x.paid + x.free + x.bump;
      var total = 0;
      for (var i = 0; i < count; i++) {
        var slot = slots[i];
        var selected = slot && byId[parseInt(slot.select.value, 10)];
        total += compare(selected || v);
      }
      return total;
    }
    function extraFor(name) { if (vol.mode !== 'product') return null; return extras[name] || (!hasFlavors ? (cfg.extras || [])[0] : null) || null; }
    function volUnit(v, name) {
      if (vol.mode === 'product') { var ev = extraFor(name === undefined ? baseOption : name); return ev ? unit(ev) : unit(v); }
      if (vol.type === 'price') return vol.unit;
      return Math.round(unit(v) * (100 - vol.pct) / 100);
    }
    function tier() { return tierIndex >= 0 ? tiers[tierIndex] : null; }
    function bumpOf(t) { return t ? t.bump : 0; }
    function bottles() { var t = tier(); return t ? t.paid + t.bump : 0; }
    function activeSlots() { var t = tier(); if (!t || !hasFlavors) return []; return t.slots.concat(t.extras.slice(0, t.bump)); }
    function values() { return activeSlots().map(function (s) { return parseInt(s.select.value, 10) || 0; }); }
    function picked() { return values().filter(Boolean).length; }
    function missing() { return hasFlavors ? activeSlots().length - picked() : 0; }
    function flavorName(id) { var f = flavorsCfg[id]; return f ? f.name : baseOption; }
    function compute() {
      var t = tier(), n = bottles(), free = t ? t.free : 0, b = base();
      var price = t ? t.paid * unit(b) + t.bump * volUnit(b, baseOption) : 0;
      var cmp = setCompare(t, b) || compare(b) * (n + free);
      var giftValue = 0;
      if (useSub || once) giftsCfg.forEach(function (g) { if (g.min <= n) giftValue += g.value || 0; }); /* free gifts: subscription, or the one-time offer */
      return { t: t, n: n, free: free, price: price, cmp: cmp, fixed: !!setCompare(t, b), giftValue: giftValue, weeks: (n + free) * weeksPer };
    }
    function freeFlavorName() { /* the free bottle line is the last line of the tier */
      var t = tier();
      if (!t || !t.free || !hasFlavors) return baseOption;
      var last = t.slots[t.slots.length - 1];
      return flavorName(parseInt(last.select.value, 10) || 0);
    }

    function paintSlot(s, index, extra) {
      var id = parseInt(s.select.value, 10) || 0, f = flavorsCfg[id];
      s.row.classList.toggle('is-filled', !!f);
      if (s.num) s.num.textContent = index + 1;
      if (s.img) { if (f && f.img) { if (s.img.getAttribute('src') !== f.img) s.img.src = f.img; s.img.hidden = false; } else { s.img.hidden = true; s.img.removeAttribute('src'); } }
      if (s.nameEl) s.nameEl.textContent = f ? f.name : '';
      if (s.trigger) s.trigger.setAttribute('aria-label', (extra ? T.slotExtra : T.slot).replace('{n}', index + 1) + (f ? ': ' + f.name : ''));
    }

    /* Flavor menu: one list, opened under whichever line was tapped */
    var menu = root.querySelector('[data-jxb-menu]');
    var menuItems = menu ? Array.prototype.slice.call(menu.querySelectorAll('[data-jxb-menu-item]')) : [];
    var menuSlot = null;
    function placeMenu() {
      if (!menu || !menuSlot) return;
      var tr = menuSlot.trigger.getBoundingClientRect(), rr = root.getBoundingClientRect();
      var width = Math.min(Math.max(tr.width, 260), rr.width);
      var left = tr.left - rr.left;
      if (left + width > rr.width) left = Math.max(0, rr.width - width);
      menu.style.top = (tr.bottom - rr.top + 4) + 'px';
      menu.style.left = left + 'px';
      menu.style.width = width + 'px';
    }
    function closeMenu() {
      if (!menu || !menuSlot) return;
      menu.hidden = true;
      menuSlot.trigger.setAttribute('aria-expanded', 'false');
      menuSlot = null;
    }
    function openMenu(s) {
      if (!menu) return;
      if (menuSlot === s) { closeMenu(); return; }
      if (menuSlot) closeMenu();
      menuSlot = s;
      var current = parseInt(s.select.value, 10) || 0;
      menuItems.forEach(function (it) { it.setAttribute('aria-selected', parseInt(it.getAttribute('data-id'), 10) === current ? 'true' : 'false'); });
      menu.hidden = false;
      s.trigger.setAttribute('aria-expanded', 'true');
      placeMenu();
      var sel = menuItems.filter(function (it) { return it.getAttribute('aria-selected') === 'true'; })[0] || menuItems[0];
      if (sel) sel.focus({ preventScroll: true });
    }
    function chooseFromMenu(item) {
      if (!menuSlot || item.disabled) return;
      var s = menuSlot;
      s.select.value = item.getAttribute('data-id');
      closeMenu();
      s.trigger.focus({ preventScroll: true });
      onSlotChange(s);
    }
    function fillEmpty(id) { /* one pick fills the other empty lines */
      if (!id) return;
      activeSlots().forEach(function (s) { if (!parseInt(s.select.value, 10)) s.select.value = String(id); });
    }
    function lastPicked() { var v = values().filter(Boolean); return v.length ? v[v.length - 1] : 0; }

    function render() {
      var c = compute(), t = c.t, noTier = !t, pk = picked(), ms = missing(), b = base();
      var xu = volUnit(b, baseOption);
      if (once) root.classList.toggle('is-once-unlocked', c.n >= onceMin);
      tiers.forEach(function (x, i) {
        var on = i === tierIndex;
        x.el.classList.toggle('is-selected', on);
        if (x.input) x.input.checked = on;
        if (x.panel) { x.panel.setAttribute('aria-hidden', on ? 'false' : 'true'); x.panel.inert = !on; } /* closed tiers: not focusable either */
        x.slots.forEach(function (s, k) { paintSlot(s, k, false); });
        x.extras.forEach(function (s, k) { s.row.hidden = k >= x.bump; paintSlot(s, x.total + k, true); if (s.price) s.price.textContent = money(xu); });
        if (x.addRow) x.addRow.hidden = x.bump >= x.extras.length;
        if (x.addNum) x.addNum.textContent = x.total + x.bump + 1;
        if (x.addBadge) {
          var lastSlot = x.slots.concat(x.extras.slice(0, x.bump)).slice(-1)[0];
          var nextVariant = lastSlot && byId[parseInt(lastSlot.select.value, 10)] || b;
          var nextPrice = volUnit(nextVariant, flavorName(nextVariant.id));
          var nextSaving = Math.max(0, compare(nextVariant) - nextPrice);
          x.addBadge.textContent = (x.addBadge.getAttribute('data-badge-template') || '')
            .replace('{price}', money(nextPrice)).replace('{diff}', moneyShort(nextSaving, fmt));
        }
        var p = unit(b) * x.paid + xu * x.bump, cm = setCompare(x, b) || compare(b) * (x.paid + x.free + x.bump);
        /* same struck value as the add-to-cart button: with "show value" on, the tier's gifts are part of it (not when the tier sets its own) */
        if (showValuePct && !setCompare(x, b) && (useSub || once)) giftsCfg.forEach(function (g) { if (g.min <= x.paid + x.bump) cm += g.value || 0; });
        if (x.priceEl) x.priceEl.textContent = money(p);
        if (x.compareEl) { x.compareEl.textContent = cm > p ? money(cm) : ''; x.compareEl.hidden = !(cm > p); }
      });
      if (el.tiersWrap) el.tiersWrap.classList.toggle('is-empty', noTier);
      if (el.box) el.box.classList.toggle('is-empty', noTier || (hasFlavors && pk === 0));
      var vp = showValuePct && !c.fixed, tv = vp ? c.cmp + c.giftValue : c.cmp, tp = tv > 0 ? Math.round((tv - c.price) / tv * 100) : 0;
      if (el.total) el.total.hidden = noTier;
      if (el.compare) { var showCmp = !noTier && tv > c.price; el.compare.textContent = showCmp ? money(tv) : ''; el.compare.hidden = !showCmp; }
      if (el.price) el.price.textContent = noTier ? '' : money(c.price);
      if (el.totalPct) el.totalPct.textContent = (!noTier && tp > 0) ? T.pct.replace('{pct}', tp) : '';
      var saved = tv - c.price;
      if (el.save) {
        var saveText = '';
        if (!noTier && saved > 0) saveText = (vp && c.giftValue > 0 && T.saveGifts) ? T.saveGifts.replace('{save}', money(saved)).replace('{gifts}', moneyShort(c.giftValue, fmt)) : T.save.replace('{save}', money(saved));
        el.save.textContent = saveText;
      }
      if (el.saving && el.savingText) {
        var showSaving = !noTier && saved > 0;
        el.savingText.textContent = '';
        if (showSaving) {
          var sp = T.saving.split('{save}');
          el.savingText.appendChild(document.createTextNode(sp[0] || ''));
          if (sp.length > 1) { var sb = document.createElement('b'); sb.textContent = money(Math.ceil(saved / 100) * 100); el.savingText.appendChild(sb); el.savingText.appendChild(document.createTextNode(sp.slice(1).join('{save}'))); }
        }
        el.saving.hidden = !showSaving;
      }
      if (el.free) {
        var showFree = c.free > 0 && T.freeBottle && pk > 0;
        el.free.textContent = showFree ? T.freeBottle.replace('{n}', c.free).replace('{flavor}', freeFlavorName()) : '';
        el.free.hidden = !showFree;
      }
      segments.forEach(function (s, i) { s.classList.toggle('is-on', i < c.n); });
      if (el.progress) el.progress.textContent = T.giftsProgress.replace('{n}', Math.min(c.n, giftMax)).replace('{max}', giftMax);
      if (el.nudge && el.nudgeText) {
        var text = '';
        if (giftsCfg.length) {
          var unlocked = giftsCfg.filter(function (g) { return g.min <= c.n; }).length;
          var next = giftsCfg.filter(function (g) { return g.min > c.n; })[0];
          if (next) {
            var k = next.min - c.n;
            text = (c.n === 0 && k === 1) ? T.giftsFirst : (k === 1 ? T.giftsNextOne : T.giftsNextMany.replace('{n}', k));
            text = text.replace('{gift}', next.title); text = next.value > 0 ? text.replace('{value}', moneyShort(next.value, fmt)) : text.replace(/\s*\(\{value\}\)|\s*\{value\}/, ''); /* $0 gifts (digital): no price */
          } else text = ((vol.on && T.giftsAllVol) ? T.giftsAllVol.replace('{price}', money(volUnit(b, baseOption))) : T.giftsAll).replace('{n}', unlocked);
        }
        el.nudgeText.textContent = text;
        el.nudge.hidden = !text;
      }
      giftEls.forEach(function (g) {
        var min = parseInt(g.getAttribute('data-unlock'), 10) || 1, on = c.n >= min, val = parseInt(g.getAttribute('data-value'), 10) || 0;
        g.classList.toggle('is-unlocked', on);
        g.classList.toggle('is-locked', !on);
        var pill = g.querySelector('[data-jxa-gift-pill]');
        if (pill) {
          pill.textContent = '';
          if (on) {
            var parts = (T.giftFree.indexOf('{value}') === -1 ? T.giftFree + ' {value}' : T.giftFree).split('{value}');
            pill.appendChild(document.createTextNode(parts[0] || ''));
            if (parts.length > 1 && val > 0) { var struck = document.createElement('s'); struck.textContent = moneyShort(val, fmt); pill.appendChild(struck); pill.appendChild(document.createTextNode(parts.slice(1).join('{value}'))); }
            else if (parts.length > 1) pill.textContent = (parts[0] + parts.slice(1).join('')).trim(); /* $0 gifts (digital): just "FREE" */
          } else pill.textContent = T.giftLocked.replace('{n}', min);
        }
      });
      var allSold = !!(b && !b.available) && (cfg.flavors || []).every(function (f) { return !f.available; });
      var label, disabled = false;
      if (allSold) { label = T.sold; disabled = true; }
      else if (noTier) { label = T.bundleBtn; disabled = true; }
      else if (ms > 0) { label = pk === 0 ? T.pickBtn : T.choose.replace('{n}', ms); disabled = true; }
      else label = T.add;
      if (busy) { label = T.adding; disabled = true; }
      if (el.submitLabel) el.submitLabel.textContent = label;
      if (el.submit) el.submit.disabled = disabled;
      if (el.ctaPrice) {
        var showPrice = !noTier && !allSold;
        el.ctaPrice.hidden = !showPrice;
        if (el.ctaTotal) el.ctaTotal.textContent = showPrice ? money(c.price) : '';
        if (el.ctaCompare) { el.ctaCompare.textContent = showPrice && tv > c.price ? money(tv) : ''; el.ctaCompare.hidden = !(showPrice && tv > c.price); }
      }
      if (el.stickyPrice) el.stickyPrice.textContent = noTier ? '' : money(c.price);
      /* Sticky bar shows the offer: "2 Bottles · + 2 FREE gifts" and the struck-through price */
      if (el.stickyTitle) {
        var tName = t && t.el.querySelector('.jxb-tier__name'), tGift = t && t.el.querySelector('.jxb-tier__sub > span');
        var offer = [tName && tName.textContent.trim(), tGift && tGift.textContent.trim().replace(/^\+\s*/, '')].filter(Boolean).join(' \u00b7 ');
        el.stickyTitle.textContent = offer || el.stickyTitle.getAttribute('data-default') || '';
      }
      if (el.stickyCompare) { var sCmp = !noTier && tv > c.price; el.stickyCompare.textContent = sCmp ? money(tv) : ''; el.stickyCompare.hidden = !sCmp; }
      if (el.stickyLabel) el.stickyLabel.textContent = disabled && !busy ? label : T.add;
      if (el.stickyBtn) el.stickyBtn.disabled = false;
      /* "Try it once" link: opens the one-time offer page with the selected bottles and flavors, priced at the full
         one-time price per bottle (no discount shown; discounts are for bundles) */
      if (el.onceLink) {
        var ol = el.onceLink;
        var onceUnit = parseInt(ol.getAttribute('data-unit'), 10) || (b ? b.price : 0);
        var onceN = addMoreEnabled ? Math.min(Math.max(1, c.n), parseInt(ol.getAttribute('data-max'), 10) || 5) : 1;
        var onceTotal = onceUnit * onceN;
        ol.textContent = (ol.getAttribute('data-label') || '').replace('{price}', money(onceTotal));
        var onceHref = ol.getAttribute('href').replace(/&(bottles|flavors)=[^&]*/g, '');
        var picks = values().filter(Boolean).slice(0, onceN);
        ol.setAttribute('href', onceHref + (onceN > 1 ? '&bottles=' + onceN : '') + (picks.length ? '&flavors=' + picks.join(',') : ''));
      }
      reconvertCurrency();
      return c;
    }

    /* Gallery: the flavor's image on pick, the tier's bundle image on tier select */
    function scrollTrackTo(slide) {
      if (!track || !slide) return;
      var left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }
    function showMedia(id) {
      if (!id) return;
      var thumb = pdp.querySelector('.jx-gal__thumb[data-media-id="' + id + '"]');
      if (thumb) { thumb.click(); return; }
      scrollTrackTo(pdp.querySelector('.jx-gal__slide[data-media-id="' + id + '"]'));
    }
    function showBundle(t) {
      var target = null, id = t ? t.id : null;
      pdp.querySelectorAll('.jx-gal__slide--bundle').forEach(function (s) {
        var on = !!(id && s.getAttribute('data-bundle-id') === id);
        s.hidden = !on;
        if (on) target = s;
      });
      if (target) scrollTrackTo(target);
    }

    function selectTier(i) {
      if (i < 0 || i >= tiers.length) return;
      var prev = values().filter(Boolean);
      tierIndex = i;
      /* carry earlier picks into the new lines, then fill the rest with the last one */
      var t = tiers[i], k = 0;
      t.slots.forEach(function (s) { if (!parseInt(s.select.value, 10) && prev[k]) s.select.value = String(prev[k++]); });
      fillEmpty(lastPicked());
      render();
      showBundle(t);
    }
    function showOnce(t) { /* one-time offer: the optional 2-bottle photo while the 2nd bottle is in */
      if (!once) return;
      showBundle(t && t.bump > 0 ? { id: 'once-2' } : null);
      if (!(t && t.bump > 0) && track) track.scrollTo({ left: 0, behavior: reduced ? 'auto' : 'smooth' });
    }
    function addMore() {
      var t = tier();
      if (!t || t.bump >= t.extras.length) return;
      closeMenu();
      var s = t.extras[t.bump];
      if (!parseInt(s.select.value, 10)) s.select.value = String(lastPicked() || baseId);
      t.bump += 1;
      render();
      showOnce(t);
      if (s.trigger && !s.trigger.disabled) s.trigger.focus({ preventScroll: true });
    }
    function removeExtra(t, k) {
      if (!t || k >= t.bump) return;
      closeMenu();
      for (var i = k; i < t.bump - 1; i++) t.extras[i].select.value = t.extras[i + 1].select.value;
      t.bump -= 1;
      render();
      showOnce(t);
      if (t.addMore && t.addRow && !t.addRow.hidden) t.addMore.focus({ preventScroll: true });
    }
    function onSlotChange(s) {
      var id = parseInt(s.select.value, 10) || 0;
      if (id) { fillEmpty(id); var f = flavorsCfg[id]; if (f) showMedia(f.media); }
      render();
    }
    function bindSlot(s) {
      if (s.trigger) s.trigger.addEventListener('click', function (e) { e.stopPropagation(); openMenu(s); });
      s.select.addEventListener('change', function (e) { e.stopPropagation(); onSlotChange(s); });
    }

    function setError(msg) { if (!el.error) return; el.error.textContent = msg || ''; el.error.hidden = !msg; }
    function addToCart() {
      if (busy || !el.submit || el.submit.disabled) return;
      var t = tier();
      if (!t) return;
      var items = [], mainCounts = {}, extraCounts = {};
      if (hasFlavors) {
        t.slots.forEach(function (s) { var id = parseInt(s.select.value, 10); if (id) mainCounts[id] = (mainCounts[id] || 0) + 1; });
        t.extras.slice(0, t.bump).forEach(function (s) { var id = parseInt(s.select.value, 10); if (id) extraCounts[id] = (extraCounts[id] || 0) + 1; });
      } else {
        mainCounts[baseId] = t.total;
        if (t.bump > 0) extraCounts[baseId] = t.bump;
      }
      /* Bottles added past the bundle ("Add more") always go in as their own cart line: the separate extra-bottle product
         when one is set, otherwise the same variant tagged _jx_extra (a different line property keeps Shopify from
         merging it into the bundle line, so a discount can price it on its own). Same subscription plan as the bundle. */
      /* One-time offer page: both lines are one-time and tagged _jx_once ('1' first bottle, '2' the added one) so the
         JCKED Discounts app takes the discount off the 2nd bottle and frees the one-time offer gift */
      Object.keys(extraCounts).forEach(function (id) {
        var ev = extraFor(flavorName(parseInt(id, 10)));
        var ix = ev ? { id: ev.id, quantity: extraCounts[id] } : { id: parseInt(id, 10), quantity: extraCounts[id] };
        ix.properties = once ? { _jx_once: '2' } : { _jx_extra: '1' };
        if (useSub && (ev ? (ev.plans && ev.plans[planId] != null) : true)) ix.selling_plan = planId;
        if (monthly && ix.selling_plan) ix.properties._jx_gift_track = 'monthly';
        items.push(ix);
      });
      Object.keys(mainCounts).forEach(function (id) {
        var it = { id: parseInt(id, 10), quantity: mainCounts[id] };
        if (useSub) it.selling_plan = planId;
        if (once) it.properties = { _jx_once: '1' };
        if (monthly && useSub) it.properties = { _jx_gift_track: 'monthly' };
        items.push(it);
      });
      if (!items.length) return;
      busy = true;
      setError('');
      render();
      el.submit.setAttribute('aria-busy', 'true');
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).filter(Boolean).join(','); body.sections_url = window.location.pathname; } catch (e) {}
      }
      var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      /* open the drawer right away with a loading state; renderContents fills it in */
      if (drawer && typeof drawer.open === 'function' && drawer.classList.contains('cart-drawer--cro')) {
        try { drawer.classList.add('is-loading'); drawer.classList.remove('is-empty'); drawer.open(el.submit); } catch (e) {}
      }
      var added = items.reduce(function (n, it) { return n + (it.properties && it.properties._jx_gift ? 0 : it.quantity); }, 0);
      var giftsHere = giftEls.length > 0; /* this product earns gifts */
      /* Gifts are worked out from the live cart: a cached copy goes stale when the cart changes elsewhere (another tab,
         an app) and would add gifts the order hasn't earned, charged at full price, or skip ones it has */
      refreshCart()
        .then(function (cart) { return alignGiftTrack(cart, monthly && useSub, rootPath); })
        .then(function (selection) {
          if (giftsHere) body.items = items.concat(giftItems(selection.cart, added, useSub, once, selection.monthly));
          return fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add to cart');
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res.json }); } catch (e) {}
          document.dispatchEvent(new CustomEvent('jx:cart:added', { detail: res.json }));
          if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res.json);
          else window.location.reload(); /* no drawer on this page: stay here, never send the visitor to /cart */
        })
        .catch(function (err) { setError(err && err.message ? err.message : 'Could not add to cart'); if (drawer && typeof drawer.close === 'function' && !drawer.querySelector('.cart-item, .cro-item')) drawer.close(); })
        .then(function () { busy = false; if (drawer) drawer.classList.remove('is-loading'); el.submit.removeAttribute('aria-busy'); render(); });
    }

    tiers.forEach(function (t, i) {
      if (t.input) t.input.addEventListener('change', function (e) { e.stopPropagation(); closeMenu(); if (t.input.checked) selectTier(i); });
      t.slots.forEach(bindSlot);
      t.extras.forEach(function (s, k) { bindSlot(s); if (s.remove) s.remove.addEventListener('click', function (e) { e.stopPropagation(); removeExtra(t, k); }); });
      if (t.addMore) t.addMore.addEventListener('click', function (e) { e.stopPropagation(); addMore(); });
    });
    menuItems.forEach(function (it) {
      it.addEventListener('click', function (e) { e.stopPropagation(); chooseFromMenu(it); });
      it.addEventListener('keydown', function (e) {
        var idx = menuItems.indexOf(it);
        if (e.key === 'ArrowDown') { e.preventDefault(); (menuItems[idx + 1] || menuItems[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (menuItems[idx - 1] || menuItems[menuItems.length - 1]).focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); var s = menuSlot; closeMenu(); if (s) s.trigger.focus(); }
        else if (e.key === 'Tab') closeMenu();
      });
    });
    document.addEventListener('click', function (e) { if (menuSlot && !menu.contains(e.target) && !menuSlot.trigger.contains(e.target)) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menuSlot) { var s = menuSlot; closeMenu(); s.trigger.focus(); } });
    window.addEventListener('resize', function () { if (menuSlot) placeMenu(); }, { passive: true });
    window.addEventListener('scroll', function () { if (menuSlot) placeMenu(); }, { passive: true });
    if (el.submit) el.submit.addEventListener('click', function (e) { e.stopPropagation(); addToCart(); });
    if (el.stickyBtn) el.stickyBtn.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToBuyBox(root);
    });
    if (el.sticky && el.submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
        el.sticky.classList.toggle('is-on', on);
        el.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (el.stickyBtn) el.stickyBtn.tabIndex = on ? 0 : -1;
      }, { threshold: 0 }).observe(el.submit);
    }
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      tiers.forEach(function (t, i) { if (t.id === id) selectTier(i); });
    });

    /* Every line starts on the current flavor so the box is ready to add */
    if (hasFlavors && flavorsCfg[baseId] && flavorsCfg[baseId].available) {
      tiers.forEach(function (t) { t.slots.concat(t.extras).forEach(function (s) { if (!parseInt(s.select.value, 10)) s.select.value = String(baseId); }); });
    }
    /* One-time offer page opened from a "Try it once" link: start with the same bottles (&bottles=) and flavors (&flavors=) */
    var startOnce = null;
    if (once) {
      var qs = new URLSearchParams(location.search);
      var wantN = parseInt(qs.get('bottles'), 10) || 1;
      var wantF = (qs.get('flavors') || '').split(',').map(function (x) { return parseInt(x, 10) || 0; }).filter(function (id) { return flavorsCfg[id] && flavorsCfg[id].available; });
      var ot = tier() || tiers[0];
      if (ot && (wantN > 1 || wantF.length)) {
        if (tierIndex < 0) tierIndex = tiers.indexOf(ot);
        if (hasFlavors && wantF[0] && ot.slots[0]) ot.slots[0].select.value = String(wantF[0]);
        ot.bump = Math.min(Math.max(0, wantN - 1), ot.extras.length);
        for (var k = 0; k < ot.bump; k++) ot.extras[k].select.value = String(wantF[k + 1] || wantF[0] || ot.extras[k].select.value || baseId);
        startOnce = ot;
      }
    }
    render();
    if (startOnce && startOnce.bump > 0) showOnce(startOnce);
  }
  if (document.querySelector('[data-jxa]')) {
    var later = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
    later(function () { refreshCart(); });
    document.addEventListener('jx:cart:added', function (e) { if (e.detail && e.detail.items) cartCache = null; refreshCart(); });
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCart, 400); }); } catch (e) {}
  }
  function initAll() {
    document.querySelectorAll('[data-jxp]').forEach(initPicker);
    document.querySelectorAll('[data-jxa]').forEach(initBundle);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll); /* theme editor re-renders the section */
})();


